const ENTITY = {
  CARRIER: "carrier_directory",
  MRF_ORDER: "mrf_orders",
  MRF: "mrfs",
  DATA_ORDER: "data_orders",
  PROJECT: "projects",
  USER: "users",
  USER_HFMA: "users_hfma",
  ORGANIZATION: "organizations",
  HOSPITAL: "hospital_directory",
}

const DELETE = {
  MRF_ORDER: "mrf-orders/delete",
  ORGANIZATION: "organizations/delete",
  HOSPITAL: "deleteHospital",
}

const ADD = {
  CARRIER: "carriers/create",
  MRF_ORDER: "mrf-orders/create",
  DATA_ORDER: "data-orders/create",
  PROJECT: "projects/create",
  USER: "users",
  USER_HFMA: "users",
  ORGANIZATION: "organizations/create",
  HOSPITAL: "hospitals/create",
}

const EDIT = {
  CARRIER: "carriers/update",
  DATA_ORDER: "data-orders/update",
  MRF_ORDER: "mrf-orders/update-index",
  PROJECT: "projects/update",
  ORGANIZATION: "organizations/update",
  HOSPITAL: "hospitals/update",
}

const GET = {
  USER_PROFILE: "users",
  CARRIER_LIST: "carriers",
  PROJECT_LIST: "projects",
  MRF_ORDER_INDEX_LIST: "mrf-orders/index-list",
  PRODUCT_COVERAGE_AREA: "coverage/area",
  SEARCH_CARRIER_PLAN_DIST_BY_MARKET_TYPE: "carriers/plan-distribution-by-market",
  SEARCH_PLANS_BY_ATTRIBUTE: "search/plans-by-attribute",
  SEARCH_CARRIER_PLAN_DIST_BY_ATT: "carriers/plan-distribution-by-attribute",
  GET_LOCATIONS_BY_TIC: "search/in-network-locations-by-tic",
  GET_PLAN_NAMES_BY_LOCATION: "search/plan-names-by-locations",
  GET_MRF_ORDER_BY_REF: "mrf-orders/get-by-reference",
  ORGANIZATION_LIST: "organizations",
  // HFMA: USERS
  USER_STATE: "api/selectors/user-management/state",
  USER_FACILITY_NAME: "api/selectors/user-management/facility-name",
}

export { ENTITY, DELETE, ADD, EDIT, GET }
